import { LoanOfferMode } from '@shared/sec-loans'
import { ExternalLinkButton } from '@ui-common/components/ExternalLinkButton'
import { PaperContainer } from '@ui-components/containers/PaperContainer'
import { LargeScreenContainer } from '@ui-components/layout/LargeScreenContainer'
import { SecondaryHeading } from '@ui-components/typography/headings/SecondaryHeading'
import { useIntl } from 'react-intl'

import { useLoanOfferAnalyticsService } from '../analytics/analyticsContext'
import { useExistingLoanOfferContext } from '../steps/LoanOfferContext'

export const ReservationFooter = ({
  reservationLink,
  loanOfferMode,
}: {
  loanOfferMode: LoanOfferMode
  reservationLink?: string
}) => {
  const intl = useIntl()
  const { step } = useExistingLoanOfferContext()
  const { analyticsService } = useLoanOfferAnalyticsService()

  if (loanOfferMode === LoanOfferMode.Manual || !reservationLink) {
    return null
  }

  return (
    <PaperContainer $largeScreenSupport={true}>
      <LargeScreenContainer>
        <SecondaryHeading
          header={intl.formatMessage({ id: 'loan-offer-common-reservation-header' })}
          leadText={intl.formatMessage({ id: 'loan-offer-common-reservation-lead-text' })}
        />
        <ExternalLinkButton
          label={intl.formatMessage({ id: 'loan-offer-common-reservation-booking-button-label' })}
          href={reservationLink}
          onClick={() => analyticsService.sendWizardStepCustomEvent(step, 'ReservationLink')}
        />
      </LargeScreenContainer>
    </PaperContainer>
  )
}
